module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "visible": _vm.centerDialogVisible,
      "close-on-click-modal": false,
      "width": "80%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.centerDialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.handleSheetClick
    },
    model: {
      value: (_vm.activeSheet),
      callback: function($$v) {
        _vm.activeSheet = $$v
      },
      expression: "activeSheet"
    }
  }, _vm._l((_vm.sheetNames), function(item, index) {
    return _c('el-tab-pane', {
      key: index,
      attrs: {
        "label": item,
        "name": item
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [(_vm.download) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleDownload
    }
  }, [_c('i', {
    staticClass: "gsk-icon-download"
  }), _vm._v("\n        " + _vm._s(_vm.$t('btn.download')) + "\n      ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    ref: "result",
    staticClass: "excel-container"
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.centerDialogVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('btn.confirm')))])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4a5e30e8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a5e30e8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/libs/previewExcel/index.vue
// module id = 1572
// module chunks = 7